<template>
    <footer class="footer">
        <div class="container-fluid">
            <div class="row text-muted">
                <div class="col-8 text-left">
                    <ul class="list-inline">
                        <li class="list-inline-item">
                            version：{{ version }}
                        </li>
                    </ul>
                </div>
                <div class="col-4 text-end">
                    <p class="mb-0">
                        &copy; 2024 - <a href="https://www.wildonetaiwan.org/" class="text-muted">野灣野生動物救援中心</a>
                    </p>
                </div>
            </div>
        </div>
    </footer>
</template>
<script>

export default {
    name:'footerView',
    
    data(){
        return {
            version:''
        }
    },
    components: {
    },
    async mounted(){
        
    },
    async created(){
        const packageJson = require('../../package.json');
        this.version = packageJson.version;
    }
  };
  </script>